import { cloneDeep } from "lodash";

export const quickMediaInit = (initialData = []) => cloneDeep(initialData);

export const quickMediaReducer = (state, action) => {
  switch (action.type) {
    case "add": {
      const { item } = action.payload;

      if (!item?.id) {
        return state;
      }

      const ids = state.map((stateItem) => stateItem.id);

      if (ids.includes(item.id)) {
        return state;
      }

      return [
        ...state,
        {
          ...cloneDeep(item),
          id: item.id,
          type: item.type,
          url: item.url,
          thumbUrl: item.thumbUrl,
        },
      ];
    }
    case "update": {
      const { id, item } = action.payload;

      if (!id) {
        return state;
      }

      return state.map((stateItem) => {
        if (stateItem.id === id) {
          return {
            ...stateItem,
            ...cloneDeep(item),
          };
        }

        return stateItem;
      });
    }
    case "remove": {
      const { id } = action.payload;

      if (!id) {
        return state;
      }

      return state.filter((stateItem) => stateItem.id !== id);
    }
    case "init": {
      return quickMediaInit(action.payload);
    }
    default: {
      return state;
    }
  }
};
